import {Component, Input, OnInit} from '@angular/core';
import {TopExposure} from '../../../../../../models/influencer';
import {Platform} from '../../../../../../models/platform';
import {DateUtils} from '../../../../../utils/date.utils';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../../services/user.service';
import {PdfExportService} from '../../../../../services/export-pdf/pdf-export.service';
import {TopExposuresComponent} from '../top-exposures.component';
import {Router} from '@angular/router';

@Component({
  selector: 'top-exposure-item',
  templateUrl: './top-exposure-item.component.html',
  styleUrls: ['./top-exposure-item.component.scss']
})
export class TopExposureItemComponent {
  @Input() topExposure: TopExposure = new TopExposure();
  @Input() platformList: Platform[] = [];
  @Input() exposureType: string;

  constructor(private translate: TranslateService,
              private userService: UserService,
              private pdfService: PdfExportService,
              private router: Router) { }

  public getPlatformIcon(): string {
    if (this.topExposure && this.topExposure.platform) {
      return this.topExposure.platform.name;
    }
    if (this.topExposure && this.topExposure.relativepath) {
      const [matchedPlatform] = this.platformList.filter((platform: Platform) =>
        this.topExposure.relativepath.indexOf(platform.description) >= 0);
      return matchedPlatform !== undefined ? matchedPlatform.name : '';
    }
    return '';
  }

  onLoadedImage() {
    this.pdfService.updateNumberImageLoaded(TopExposuresComponent.COMPONENT_NAME);
  }

  onLoadedImageError() {
    console.log('Top exposure load image fail');
    this.pdfService.updateNumberImageLoaded(TopExposuresComponent.COMPONENT_NAME);
  }

  /**
   * this method is used to format number data in top-exposure section
   * Example:
   * For Reach and Engagement data:
   * 11650 should be formatted 11,650
   * 120 should be formatted 120
   * 1000000 should be formatted 1,000,000
   * For Impact data:
   * 78 should be formatted 78%
   * @param value
   * @returns {string}
   */
  public formatExposureNumber(value): string {
    const formattedNumber = Number(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (this.exposureType === this.translate.instant('INFLUENCER.insight.top_exposure.impact')) {
      return this.translate.instant('common.percent_formatter', {value: formattedNumber});
    } else {
      return formattedNumber;
    }
  }

  public formatExposureDate(date: string): string {
    return DateUtils.formatDate(date);
  }

  get activeAccount() {
    return this.userService.getCompanyId();
  }

  openPostPage() {
    const currentInfluencer = this.userService.getInfluencerInfo();
    // influencer platform version
    if (currentInfluencer) {
      return this.router.navigate(['dashboard', 'post', this.topExposure.urlHash]);
    } else {
      return this.router.navigate(['post'], {queryParams: {
        influencerId: this.topExposure.influencer_id,
        urlHash: this.topExposure.urlHash,
        fullUrl: this.topExposure.url,
        relativePath: this.topExposure.relativepath,
        activeAccount: this.activeAccount
      }});
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposures/top-exposure-item/top-exposure-item.component.ts